import {HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {ApiTokenService} from './ApiTokenService';

@Injectable()
export class NoCacheHeadersInterceptor implements HttpInterceptor {
  constructor(private apiTokenService: ApiTokenService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    const isApiRequest = req.url.startsWith(environment.apiUrl);
    const token = this.apiTokenService.getToken();
    const setHeaders: Record<string, string> = {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    };

    if (isApiRequest && token) {
      setHeaders.Authorization = `Bearer ${token}`;
    }

    const authReq = req.clone({setHeaders});
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (isApiRequest && error.status === 401) {
          void this.apiTokenService.handleUnauthorizedResponse();
        }
        return throwError(() => error);
      })
    );
  }
}
